const InvestmentsChallenge1Dataset = {
    
    items: {
        "item-1": { id: "item-1", content: "Investing involves risk, including the possibility of losing money.", 
                answer: "column-2" },
        "item-2": { id: "item-2", content: "Higher risk always means a higher reward.", 
                answer: "column-1" },
        "item-3": { id: "item-3", content: "A 401(k) is a good place to save money for a downpayment for a home.",
                answer: "column-1" },
        "item-4": { id: "item-4", content: "It is a good idea to use some 1-year CDs to save for a vacation " +
                "that you are hoping to take 3 to 4 years in the future.",
                answer: "column-2" },
        "item-5": { id: "item-5", content: "All types of investments are essentially the same.  " +
                "You can just choose one at random.", 
                answer: "column-1" },
        "item-6": { id: "item-6", content: "If a stock price is going up, you should buy it as fast as you can.", 
                answer: "column-1" }, 
        "item-7": { id: "item-7", content: "Diversifying your investments can reduce overall risk.", 
                answer: "column-2" },   
        "item-8": { id: "item-8", content: "A 401(k) is a type of retirement investment account.", 
                answer: "column-2" },    
        "item-9": { id: "item-9", content: "Real Estate can be a good long-term investment.",
                answer: "column-2"},
        "item-10": { id: "item-10", content: "You're fully diversified as long as you own a " +
                "lot of different stocks, even if they're all from the same industry..",
                answer: "column-1"}
 
    },
    columns: {
        "column-1": { id: "column-1", title: "Statements that are False", 
            itemIds: ['item-1', 'item-2', 'item-3', "item-4", "item-5", "item-6", "item-7",
                "item-8", "item-9", "item-10"
            ] },
        "column-2": { id: "column-2", title: "Statements that are True", itemIds: [] },
        
              
    },
    columnOrder: ["column-1", "column-2",]
}

export default InvestmentsChallenge1Dataset